import CryptoJS from "crypto-js";

export const encryptData = (data) => {
    const ciphertext = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(data), process.env.REACT_APP_secretKey).toString());
    return ciphertext;
};
